import React, { useEffect, useState } from "react";

import DialerCampaignSkipTracePanel from "assets/images/campaigns/dialer-campaign-skip-trace-panel.svg";
import PersonSearch from "assets/images/person-search.svg";
import SkipTraceHandler from 'app/components/SkipTraceHandler';
import css from "./style.scss";

const SkipTracePanel = ({ contactIds }) => {

  const [skipTraceContactIds, setSkipTraceContactIds] = useState(null);
  const [startSkipTrace, setStartSkipTrace] = useState(false);

  const handleSkipTraceProcessed = () => {
    // Reset state after handler processes the request
    setStartSkipTrace(false);
  };

  return (
    <>
      <div className={css.skipTracePanel}>
        <img src={DialerCampaignSkipTracePanel} alt="DialerCampaignSkipTracePanel" />

        <div className={css.skipTracePanelText}>
          You don't have any numbers available yet. Skip<br />
          Trace this list for free to start making calls directly<br />
          from PropStream and streamline your outreach.
        </div>

        <div className={css.upgradeBtnWrapper} onClick={() => {
          setSkipTraceContactIds(contactIds);
          setStartSkipTrace(true);
        }}>
          <button className={css.upgradeBtn}>
            <img src={PersonSearch} alt="PersonSearch" />
            <span className={css.upgradeBtnTxt}>Skip Trace</span>
          </button>
        </div>
      </div>

      <SkipTraceHandler 
        contactIds={skipTraceContactIds} 
        startSkipTrace={startSkipTrace}
        onProcessed={handleSkipTraceProcessed}
      />
    </>
  );
};

export default SkipTracePanel;
